import DrawerVersion3 from "./index_v3"

export default DrawerVersion3;
